import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import { View, Text, TouchableOpacity, Clipboard } from 'react-native';

import AudioMessage from './AudioMessage';
import { detectURL, ImageToBase64 } from '../../../functions';
import { CaptionBoldDark, ProfileAvatar } from '../../../components';
import styles from '../../../styles';
import { global } from '../../../const';
import { getWcUsersInfo } from '../../../action';
import { placeholder } from "../../../assets";
import localize from '../../../localize';

class ReceiveMessage extends PureComponent {

    state = {
        senderName: "",
        senderIcon: placeholder,
    }

    componentWillMount = async () => {
        let user = this.props.users[this.props.data.sender]
        // console.log("user",user)
        if (!user || user === null) {
           
            user = await this.props.getWcUsersInfo(this.props.data.sender)
            // console.log("user",user)
            user = user[0];
          
        }

        let image_url = global.MAKEURL(user.avatar);
        if (window.Base64Img[user.avatar])
            image_url = window.Base64Img[user.avatar]
        this.setState({
            senderName: user.login_name ? user.login_name : localize.MISSING + this.props.data.sender,
            senderIcon: user.avatar ? { uri: image_url } : placeholder
        })

        if (!window.Base64Img[user.avatar]) {
            let base64 = await ImageToBase64(image_url);
            window.Base64Img = Object.assign(window.Base64Img || {}, { [user.avatar]: base64 })
        }
    }

    onMessagePressed = () => {
        Clipboard.setString(this.props.data.message);
    }

    render() {
        let { message, id, type, kind, time, riddle_key } = this.props.data;
        if (Number(type) === 0) message = detectURL(message)

        if (Number(type) === 2) {
            let voiceMsg = message.split('^');
            voiceMsg = voiceMsg[0] || 0;
            if (!Number(voiceMsg)) voiceMsg = 0;
            // if (voiceMsg === 0) return null;
        }

        return (
            <View style={{ marginVertical: 6 }}>
                <View style={{ marginLeft: 50, height: 16 }}><CaptionBoldDark title={this.state.senderName} /></View>

                <View style={{ flexDirection: 'row', alignSelf: 'flex-start', alignItems: 'flex-end' }}>

                    <View style={{ width: 35, height: 35 }}>
                        <ProfileAvatar src={this.state.senderIcon} />
                    </View>

                    {
                        Number(type) === 2 ?
                            <AudioMessage
                                type={0}
                                url={message}
                                id={global.database + id}
                                kind={Number(kind)}
                                ans={riddle_key}
                                time={time} />
                            :
                            <TouchableOpacity
                                onLongPress={this.onMessagePressed}
                                activeOpacity={1}
                                style={[styles.msgContainerReceive, styles.bgUltralight]} >
                                <Text style={[{ fontFamily: 'NotoSans-Regular', fontSize: 15, maxWidth: 275 }, styles.cD]}
                                    dangerouslySetInnerHTML={{ __html: message }}
                                ></Text>
                            </TouchableOpacity>
                    }

                </View>
            </View>
        )
    }
}


const mapStateToProps = ({ auth }) => {
    return {
        users: auth.users
    }
}
const mapDispatch = (dispatch) => {
    return {
        getWcUsersInfo: request => dispatch(getWcUsersInfo(request))
    }
}
export default connect(mapStateToProps, mapDispatch)(ReceiveMessage);